// Monta o payload "Pix Copia e Cola" (BR Code / EMV) para gerar um QR Code
// pagável diretamente pelo app do banco. Formato padrão Bacen.
// ponytail: sem suporte a QR dinâmico (webhook de confirmação) — só estático com valor fixo, suficiente para fatura.

function tlv(id: string, value: string): string {
  return `${id}${String(value.length).padStart(2, "0")}${value}`;
}

function sanitizar(texto: string, maxLen: number): string {
  // NFD separa acentos em marcas combinantes; strip-ASCII abaixo já remove tudo não-ASCII, marcas incluídas.
  const semAcento = texto.normalize("NFD").replace(/[^\x20-\x7E]/g, "").trim();
  return (semAcento || "NA").slice(0, maxLen);
}

function crc16(payload: string): string {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? ((crc << 1) ^ 0x1021) & 0xffff : (crc << 1) & 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
}

export function montarPixCopiaCola(opts: {
  chave: string;
  nomeRecebedor: string;
  cidade: string;
  valor?: number;
}): string {
  const merchantAccount = tlv("00", "br.gov.bcb.pix") + tlv("01", opts.chave.trim());
  let payload =
    tlv("00", "01") +
    tlv("26", merchantAccount) +
    tlv("52", "0000") +
    tlv("53", "986") +
    (opts.valor && opts.valor > 0 ? tlv("54", opts.valor.toFixed(2)) : "") +
    tlv("58", "BR") +
    tlv("59", sanitizar(opts.nomeRecebedor, 25)) +
    tlv("60", sanitizar(opts.cidade, 15)) +
    tlv("62", tlv("05", "***"));

  payload += "6304";
  return payload + crc16(payload);
}
